import { ChargeFormEntry } from "../../types";

export const getTotalRow = (accountingData: ChargeFormEntry[]) =>
  accountingData.filter(charge => charge.code !== "document").reduce(
    (prev, curr) => ({
      amount: prev.amount + curr.amount,
      tax: prev.tax + curr.tax,
      buyerAtclosing: prev.buyerAtclosing + curr.buyer_at,
      buyerBefore: prev.buyerBefore + curr.buyer_before,
      sellerAtclosing: prev.sellerAtclosing + curr.seller_at,
      sellerBefore: prev.sellerBefore + curr.seller_before,
      otherTotal: prev.otherTotal + curr.by_others,
    }),
    {
      amount: 0,
      tax: 0,
      buyerAtclosing: 0,
      buyerBefore: 0,
      sellerAtclosing: 0,
      sellerBefore: 0,
      otherTotal: 0,
    }
  );